import NewAxiosInstance from "../../../api/api";
import { ITablePagination } from "../../../types/commonTypes";
import { obj2url } from "../../../utils/utils";

export const voicebotLogsApi = async (phoneNumber: string) => {
  return await NewAxiosInstance().get(
    `/crm/voicebot/call/logs?phoneNumber=${phoneNumber}`
  );
};

export const voicebotCallListApi = async (
  pageData: ITablePagination,
  data: any
) => {
  return await NewAxiosInstance().get(
    `/crm/voicebot/call/vbOutcome?take=${pageData.take}&skip=${pageData.skip}` +
      obj2url(data)
  );
};
